import Page from '../components/Page';
import React from 'react';
import {
    Button,
    ButtonGroup,
    Card,
    CardBody,
    CardHeader,
    Col,
    Collapse,
    FormGroup,
    Label,
    Row,
    Table,
} from 'reactstrap';
import BasePage from './BasePage';
import SearchInput from '../components/SearchInput';
import {deleteParam, isFailed, isSuccess, navigatePage, parseDate,} from '../utils/Utilities';
import ItemOption from '../components/Widget/ItemOption';
import {IoMdSettings} from 'react-icons/io/index';
import {MdRestore} from 'react-icons/md/index';
import {FaFileExcel} from 'react-icons/fa/index';
import Pagination from '../components/Pagination';
import queryString from 'query-string';
import {FaInfo, FiArrowDownCircle, FiArrowUpCircle} from 'react-icons/all';
import DateInput from '../components/Widget/DateInput';
// import label, {GENDERS} from '../message/Label';
import label from 'enqc-utilities/src/label/Label'
import PrimaryCardHeader from "../components/Widget/PrimaryCardHeader";
import DropdownInput from "../components/form/DropdownInput";
import {delegateObjectsForSelection} from "enqc-utilities/src/utils/Utilities";
import Endpoint from "enqc-utilities/src/api/Endpoint";
import ModelModal from "../components/modal/ModelModal";
import UserButton from "../components/Widget/UserButton";
import StatusWidget from "../components/Widget/StatusWidget";
import {ASSEMBLY_STATUS_COLOR, RELEASE_VERIFICATION_STATUS_COLOR} from "enqc-utilities/src/utils/Global";
import Global, {_TAKEN, DD_MMMM_YYYY_HH_MM_SS, INSPECTION_STATUS_COLOR} from "../utils/Global";
import ApplicationIcons from "enqc-utilities/src/misc/ApplicationIcons";
import AssemblyDetailModal from "../components/modal/AssemblyDetailModal";
import InspectionEventDetailModal from "../components/modal/InspectionEventDetailModal";
import ReleaseVerificationDetailModal from "../components/modal/ReleaseVerificationDetailModal";
import ContinueInspectionConfirmModal from "../components/modal/ContinueInspectionConfirmModal";
import InspectionFormCheckPage from "./InspectionFormCheckPage";
import CreateInspectionConfirmModal from "../components/modal/CreateInspectionConfirmModal";
import CreateInspectionSuccessModal from "../components/modal/CreateInspectionSuccessModal";
import ContinueReleaseVerificationConfirmModal from "../components/modal/ContinueReleaseVerificationConfirmModal";

var clone = require('safe-clone-deep');


class AllTaskPage extends BasePage{

    constructor(props) {
        super(props);
        this.state ={
            allTasks : [],
            allTask:{},
            modalDeleteConfirm:false,
            ascending:false,
            sortir:'created',
            search:"",
            page :queryString.parse(this.props.query).page?queryString.parse(this.props.query).page:1,
            totalPage:0,
            totalElement:0,
            pageElement:0,
            createdStartDate:null,
            createdEndDate:null,
            updatedStartDate:null,
            updatedEndDate:null,
            gender:{},
            allTaskStatus:{},
            allTaskRoles:[],
            allTaskRole:{},
            allTaskFilterExpand:false,
            allTaskTransactionExpand:false,
            modelModal:false,
            model:{},
            models:[],
            selectedModelOption:{},
            assemblyStatuses:[],
            inspectionStatuses:[],
            releaseVerificationStatuses:[],
            selectedAssemblyStatus:{},
            selectedInspectionStatus:{},
            selectedReleaseVerificationStatus:{},
            createInspectionConfirmModal:false,
            assemblyDetailModal:false,
            assembly:{},
            inspectionDetailModal:false,
            continueInspectionConfirmModal:false,
            inspection:{},
            releaseVerificationDetailModal:false,
            continueReleaseVerificationConfirmModal:false,
            releaseVerification:{},
        }

    }


    componentWillReceiveProps(props, nextContext) {
        if(props!=this.props){
            this.setState({
                page:queryString.parse(props.query).page?queryString.parse(props.query).page:1
            }, async () => {
                await this.fetchAll(this.state.ascending, this.state.sortir, this.state.search, true)
            })
        }
    }

    async componentDidMount() {
        super.componentDidMount();
        this.fetchAssemblyStatus()
        this.fetchInspectionStatus()
        this.fetchReleaseVerificationStatus()
        await this.fetchAll(this.state.ascending, this.state.sortir, this.state.search, true)

    }

    fetchAssemblyStatus = () => {
        this.get(Endpoint.API.ASSEMBLY_STATUSES, {
            params :{
                sortir: "id",
                ascending:true,
            }
        }, null, response=>{
            if(response.code===200){
                let assemblyStatuses = response.data
                assemblyStatuses = this.appendDefaultStatus(assemblyStatuses);
                this.setState({assemblyStatuses})
            }
        }, false, true)
    }

    fetchInspectionStatus = () => {
        this.get(Endpoint.API.INSPECTION_STATUSES, {
            params :{
                sortir: "id",
                ascending:true,
            }
        }, null, response=>{
            if(response.code===200){
                let inspectionStatuses = response.data
                inspectionStatuses = this.appendDefaultStatus(inspectionStatuses);
                this.setState({inspectionStatuses})
            }
        }, false, true)
    }

    fetchReleaseVerificationStatus = () => {
        this.get(Endpoint.API.RELEASE_VERIFICATION_STATUSES, {
            params :{
                sortir: "id",
                ascending:true,
            }
        }, null, response=>{
            if(response.code===200){
                let releaseVerificationStatuses = response.data
                releaseVerificationStatuses = this.appendDefaultStatus(releaseVerificationStatuses);
                this.setState({releaseVerificationStatuses})
            }
        }, false, true)
    }

    fetchAssemblyBasicInformation(id){
        this.showProgress()
        this.get(Endpoint.API.ASSEMBLY_BASIC_INFORMATION, {
            params :{
                id : id
            }
        }, null, response=>{
            if(response.code===200){
                let assembly = response.data
                this.setState({
                    assembly, assemblyDetailModal:true
                }, () => {
                    this.closeProgress()
                })
            }
        }, false, true)
    }

    fetchInspectionDetail = (id) => {
        this.get(Endpoint.API.INSPECTION_BASIC_INFORMATION, {
            params: {
                id: id
            }
        }, null, response => {
            if (response.code === 200) {
                let inspection = response.data
                this.setState({
                    inspection: inspection, inspectionDetailModal:true
                })
            }
        }, true, true)
    }

    fetchReleaseVerificationDetail = (id) => {
        this.get(Endpoint.API.RELEASE_VERIFICATION, {
            params: {
                id: id
            }
        }, null, response => {
            if (response.code === 200) {
                let releaseVerification = response.data
                this.setState({
                    releaseVerification: releaseVerification, releaseVerificationDetailModal:true
                })
            }
        }, true, true)
    }


    updateInspection = (inspectionEvent) => {
        this.post(Global.API.INSPECTION_COMMIT+"/"+_TAKEN, clone(inspectionEvent), null, response=>{
            if(response.code===200){
                inspectionEvent = response.data;
                this.successToast(response.message)
                this.props.history.push(InspectionFormCheckPage.BASE_ENDPOINT+"/"+inspectionEvent.inspection.reference)
            }else{
                this.errorToast(response.message)
            }
        }, true, true)
    }

    createInspection = async (assembly) => {
        let {model} = assembly
        let validationParams = {params:{modelId:model.id, reference:assembly.reference}};
        this.showProgress()
        let response = await this.asyncGet(Global.API.MODEL_VALID_TO_APPLY, validationParams, null, false, true)
        if(isFailed(response)){
            this.openFailedDialog(label.Failed, response.message)
            return
        }
        let params = {params:{assemblyId:assembly.id}}
        response = await this.asyncGet(Global.API.INSPECTION_CREATE, params, null, false, true)
        this.closeProgress()
        if(isSuccess(response)){
            let inspection = response.data;
            this.setState({
                createInspectionConfirmModal:false,
                createInspectionSuccessModal:true,
                inspection
            })
        }else if(isFailed(response)){
            this.errorToast(response.message)
        } else{
            this.errorToast(label.Failed)
        }
    }




    appendDefaultStatus(statuses){
        let defaultStatus = {
            id:0,
            label:label.All,
            name:label.All,
            active:true,
            iconLink:ApplicationIcons.Icons.lines,
        }
        statuses.unshift(defaultStatus)
        return statuses
    }


    resetFilter(){
        this.setState({
            search:"",
            page :1,
            totalPage:0,
            totalElement:0,
            pageElement:0,
            createdStartDate:null,
            createdEndDate:null,
            updatedStartDate:null,
            updatedEndDate:null,
            selectedAssemblyStatus:{},
            selectedInspectionStatus:{},
            selectedReleaseVerificationStatus:{},
        }, () => {
            navigatePage(this.props, 1)
        })
    }

    fetchAll = async (ascending, sortir, search, progressing, excelMode) => {
        let {selectedAssemblyStatus, selectedInspectionStatus, selectedReleaseVerificationStatus, createdStartDate, createdEndDate, updatedStartDate, updatedEndDate, page} = this.state
        let selectedAssemblyStatusId = undefined
        if(selectedAssemblyStatus.id!=0){
            selectedAssemblyStatusId = selectedAssemblyStatus.id
        }
        let selectedInspectionStatusId = undefined
        if(selectedInspectionStatus.id!=0){
            selectedInspectionStatusId = selectedInspectionStatus.id
        }
        let selectedReleaseVerificationStatusId = undefined
        if(selectedReleaseVerificationStatus.id!=0){
            selectedReleaseVerificationStatusId = selectedReleaseVerificationStatus.id
        }

        let params = {
            page:page-1,
            ascending:ascending,
            sortir:sortir,
            search:search,
            createdStartDate:createdStartDate,
            createdEndDate:createdEndDate,
            updatedStartDate:updatedStartDate,
            updatedEndDate:updatedEndDate,
            assemblyStatusId:selectedAssemblyStatusId,
            inspectionStatusId:selectedInspectionStatusId,
            releaseVerificationStatusId:selectedReleaseVerificationStatusId,
            excelMode:excelMode?excelMode:false
        }
        if(excelMode){
            await this.asyncDownloadGet(Endpoint.API.RELEASE_VERIFICATION_ALL_TASKS, {params:params}, null,true);
            return
        }else{
            let res = await this.asyncGet(Endpoint.API.RELEASE_VERIFICATION_ALL_TASKS, {params:params}, null, progressing, true);
            if(res.code === 200){
                this.setState({
                    allTasks : res.data,
                    totalPage: res.totalPage,
                    totalElement: res.totalElement,
                    pageElement: res.pageElement,
                })
            }
        }
    }

    fetchModelDetail = async (id) => {
        let {modelModal} = this.state
        if(id){
            let response = await this.asyncGet(Endpoint.API.MODEL, {
                params :{
                    id : id
                }
            }, undefined, true, true)
            if(response.code===200){
                let model = response.data
                this.setState({
                    model:model,
                    modelModal:true
                })
            }else{
                this.props.history.goBack();
            }

        }
    }


    closeDialog = () =>{
        this.setState({
            modalAddConfirm:false,
            modalDeleteConfirm:false
        })
    }

    refreshAllTask = (ascending, sortir, progressing) => (
        this.setState({
            ascending:ascending,
            sortir:sortir
        }, async () => {
            await this.fetchAll(this.state.ascending, this.state.sortir, this.state.search, progressing)
        })
    )


    render() {
        var i = 0 ;
        let {totalPage, totalElement, pageElement, modelModal, model, models, selectedModelOption,
            assemblyStatuses, inspectionStatuses, releaseVerificationStatuses,
            selectedAssemblyStatus, selectedInspectionStatus, selectedReleaseVerificationStatus,
            createInspectionConfirmModal, createInspectionSuccessModal, assemblyDetailModal, assembly,
            inspectionDetailModal, continueInspectionConfirmModal, inspection, releaseVerificationDetailModal, continueReleaseVerificationConfirmModal, releaseVerification
        } = this.state
        if(!selectedModelOption){
            selectedModelOption = {}
        }
        if(!models){
            models = []
        }


        return (

            <Page
                title={label.AllTasks}
                breadcrumbs={[{ name: label.AllTasks, active: true }]}
                className="TablePage">
                {super.render()}

                <ModelModal
                    show={modelModal}
                    model={model}
                    onClickOk={()=>{
                        this.setState({modelModal:false})
                    }}/>
                <AssemblyDetailModal
                    show={assemblyDetailModal}
                    assembly={assembly}
                    onContinueInspection={(assembly) => {
                        this.setState({createInspectionConfirmModal:true, assemblyDetailModal:false, assembly})
                    }}
                    onViewInspection={(assembly) => {
                        this.setState({assemblyDetailModal:false, assembly:{}}, () => {
                            this.fetchInspectionDetail(assembly.inspection.id)
                        })
                    }}
                    onClose={() => {
                        this.setState({assemblyDetailModal:false, assembly:{}})
                    }}/>
                <CreateInspectionConfirmModal
                    show={createInspectionConfirmModal}
                    assembly={assembly}
                    onClickOk={async (assembly) => {
                        await this.createInspection(assembly)
                    }}
                    onClickCancel={() => {
                        this.setState({
                            scanModal:true,
                            createInspectionConfirmModal:false,
                            inspection:undefined
                        })
                    }}
                />
                <CreateInspectionSuccessModal
                    show={createInspectionSuccessModal}
                    onClickOk={()=>{
                        this.props.history.push(InspectionFormCheckPage.BASE_ENDPOINT+'/'+inspection.reference)
                    }}
                    onClickCancel={()=>{
                        this.setState({
                                createInspectionSuccessModal:false, inspection:{}}
                            , () => {
                                this.refreshDashboard()
                            })
                    }}
                    inspection={inspection}/>


                <InspectionEventDetailModal
                    show={inspectionDetailModal}
                    inspection={inspection}
                    model={inspection.model??{}}
                    inspectionEvent={inspection.currentInspectionEvent}
                    onContinueInspection={(inspectionEvent)=>{
                        this.setState({
                            continueInspectionConfirmModal:true,
                            inspectionDetailModal:false
                        })
                    }}
                    onClose={()=>{
                        this.setState({inspectionDetailModal:false})
                    }}
                />
                <ContinueInspectionConfirmModal
                    show={continueInspectionConfirmModal}
                    inspection={inspection}
                    model={inspection.model}
                    onClickOk={() => {
                        this.setState({
                            continueInspectionConfirmModal:false,
                        }, () => {
                            // alert(JSON.stringify(inspection.currentInspectionEvent))
                            let inspectionEvent = inspection.currentInspectionEvent
                            inspectionEvent.inspection = inspection;
                            this.updateInspection(inspectionEvent)
                        })
                    }}
                    onClickCancel={() => {
                        this.setState({
                            inspection:{},
                            continueInspectionConfirmModal:false,
                        })
                    }}
                />

                <ReleaseVerificationDetailModal
                    show={releaseVerificationDetailModal}
                    releaseVerification={releaseVerification}
                    onContinueReleaseVerification={(releaseVerification)=>{
                        this.setState({
                            releaseVerification,
                            releaseVerificationDetailModal:false,
                            continueReleaseVerificationConfirmModal:true,
                        })
                    }}
                    onClose={()=>{
                        this.setState({releaseVerificationDetailModal:false})
                    }}
                />
                <ContinueReleaseVerificationConfirmModal
                    show={continueReleaseVerificationConfirmModal}
                    onClickOk={() => {
                        this.setState({
                            continueReleaseVerificationConfirmModal:false,
                        }, () => {
                            this.updateReleaseVerification(releaseVerification)
                        })
                    }}
                    onClickCancel={() => {
                        this.setState({continueReleaseVerificationConfirmModal:false, releaseVerification:{}})
                    }}
                    releaseVerification={releaseVerification} />


                <Row key={1}>
                    <Col>
                        <Card>
                            <PrimaryCardHeader
                                content={(
                                    <React.Fragment>
                                        {
                                            (this.state.allTaskFilterExpand)?(<FiArrowUpCircle/>):((<FiArrowDownCircle/>))
                                        }
                                        &nbsp;{label.AdvanceFilter} ({label.ClickToExpandFilterContent})
                                    </React.Fragment>
                                )}
                                style={{cursor:'pointer'}}
                                onClick={(e)=>{
                                    e.preventDefault()
                                    this.setState({
                                        allTaskFilterExpand:!this.state.allTaskFilterExpand
                                    })
                                }}
                            />
                            <Collapse isOpen={this.state.allTaskFilterExpand}>
                                <CardHeader>
                                    <Row>
                                        <Col md={3}>
                                            <Label for="createdStartDate">{label.CreatesStartDate}</Label>
                                            <DateInput
                                                id="createdStartDate"
                                                value={this.state.createdStartDate}
                                                maxdate={this.state.createdEndDate}
                                                onChange={(e) =>{
                                                    let value = e.target.value
                                                    this.setState({
                                                        createdStartDate : value?value:null
                                                    })
                                                }}
                                                placeholder={label.EnterStartDate}
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <Label for="createdEndDate">{label.CreatesEndDate}</Label>
                                            <DateInput
                                                id="createdEndDate"
                                                mindate={this.state.createdStartDate}
                                                value={this.state.createdEndDate}
                                                onChange={(e) =>{
                                                    let value = e.target.value
                                                    this.setState({
                                                        createdEndDate :  value?value:null
                                                    })
                                                }}
                                                placeholder={label.EnterEndDate}
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <Label for="updatedStartDate">{label.UpdatesStartDate}</Label>
                                            <DateInput
                                                id="updatedStartDate"
                                                value={this.state.updatedStartDate}
                                                maxdate={this.state.updatedEndDate}
                                                onChange={(e) =>{
                                                    let value = e.target.value
                                                    this.setState({
                                                        updatedStartDate : value?value:null
                                                    })
                                                }}
                                                placeholder={label.EnterStartDate}
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <Label for="updatedEndDate">{label.UpdatesEndDate}</Label>
                                            <DateInput
                                                id="updatedEndDate"
                                                mindate={this.state.updatedStartDate}
                                                value={this.state.updatedEndDate}
                                                onChange={(e) =>{
                                                    let value = e.target.value
                                                    this.setState({
                                                        updatedEndDate :  value?value:null
                                                    })
                                                }}
                                                placeholder={label.EnterEndDate}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={4}>
                                            <FormGroup>
                                                <ItemOption
                                                    title={label.SelectAssemblyStatus}
                                                    fieldForLabel={"name"}
                                                    objects={assemblyStatuses}
                                                    default={selectedAssemblyStatus.id}
                                                    callback={(assemblyStatus)=>{
                                                        this.setState({
                                                            selectedAssemblyStatus:assemblyStatus,
                                                        })
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={4}>
                                            <FormGroup>
                                                <ItemOption
                                                    title={label.SelectInspectionStatus}
                                                    fieldForLabel={"name"}
                                                    objects={inspectionStatuses}
                                                    default={selectedInspectionStatus.id}
                                                    callback={(inspectionStatus)=>{
                                                        this.setState({
                                                            selectedInspectionStatus:inspectionStatus,
                                                        })
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={4}>
                                            <FormGroup>
                                                <ItemOption
                                                    title={label.SelectReleaseVerificationStatus}
                                                    fieldForLabel={"name"}
                                                    objects={releaseVerificationStatuses}
                                                    default={selectedReleaseVerificationStatus.id}
                                                    callback={(releaseVerificationStatus)=>{
                                                        this.setState({
                                                            selectedReleaseVerificationStatus:releaseVerificationStatus,
                                                        })
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <Row>
                                                <Col>
                                                    <Card>
                                                        <CardHeader>
                                                            {label.TotalRecord}
                                                        </CardHeader>
                                                        <CardBody>
                                                            <h4 style={{color:'green'}}><strong>{totalElement}</strong></h4>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                                <Col>
                                                    <Card>
                                                        <CardHeader>
                                                            {label.TotalPage}
                                                        </CardHeader>
                                                        <CardBody>
                                                            <h4 style={{color:'blue'}}>{totalPage}</h4>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col md={6}>
                                            <Row>
                                                <Col md={6}>
                                                    <Button
                                                        block
                                                        className={"float-left btn-main"}
                                                        color={"none"}
                                                        onClick={event => {
                                                            navigatePage(this.props, 1)
                                                        }}><IoMdSettings/>&nbsp;{label.ApplyFilter}</Button>
                                                </Col>
                                                <Col md={6}>
                                                    <Button
                                                        block
                                                        className={"float-left btn-white-normal"}
                                                        color={"none"}
                                                        onClick={event => {
                                                            this.resetFilter()
                                                        }}><MdRestore/>&nbsp;{label.ResetFilter}</Button>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={12}>
                                                    <Button block className={"float-left"} color={"green"}
                                                            onClick={async (event) => {
                                                                await this.fetchAll(this.state.ascending, this.state.sortir, this.state.search, true, true)
                                                            }}>
                                                        <FaFileExcel/>&nbsp;{label.DownloadExcel}
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </CardHeader>
                            </Collapse>
                        </Card>
                    </Col>
                </Row>
                {this.renderAllTasksTable()}
            </Page>
        );
    }

    renderAllTasksTable(){
        let {ascending, sortir, totalPage, totalElement, pageElement, allTasks} = this.state
        if(!allTasks){
            allTasks = []
        }
        let orderOptions = delegateObjectsForSelection(
            {name:label.Reference, field:'ji.reference'},
            {name:label.Created, field:'created'},
            {name:label.Updated, field:'updated'},
        )
        let ascendingOptions = delegateObjectsForSelection( {name:label.Descending, field:false}, {name:label.Ascending, field:true})

        return (
            <React.Fragment>
                <Row key={2}>
                    <Col>
                        <Card>
                            <CardHeader>
                                <strong>{label.AllTasks}</strong>
                                <br/><br/>
                                <Row>
                                    <Col md={7}>
                                        <ButtonGroup className="d-flex w-100">
                                            <DropdownInput
                                                title={label.SortBy}
                                                options={orderOptions}
                                                onSelect={(item) => {
                                                    this.refreshAllTask(ascending, item.field, true)
                                                }}
                                                onReset={() => {
                                                    this.refreshAllTask(ascending, "created", true)
                                                }}/>
                                            &nbsp;&nbsp;&nbsp;
                                            <DropdownInput
                                                options={ascendingOptions}
                                                onSelect={(item) => {
                                                    this.refreshAllTask(item.field, sortir, true)
                                                }}
                                                onReset={() => {
                                                    this.refreshAllTask(true, sortir, true)
                                                }}/>
                                        </ButtonGroup>
                                    </Col>
                                    <Col md={5} className="text-right">
                                        <FormGroup>
                                            <SearchInput
                                                placeholder={label.SearchVerificationByReferenceSerialModelAndUserManufacturingSite}
                                                value={this.state.search}
                                                onChange={e=>{
                                                    this.setState({
                                                        search:e.target.value
                                                    }, () => {
                                                        if(this.state.search===''){
                                                            deleteParam(this.props, "page")
                                                        }
                                                    })
                                                }}
                                                onEnter={e=>{
                                                    if(this.state.search!==''){
                                                        deleteParam(this.props, "page")
                                                    }
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Table responsive hover>
                                        <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>{label.Reference} / {label.SerialCode}</th>
                                            <th>{label.Model}</th>
                                            <th>{label.Assembly}</th>
                                            <th>{label.Inspection}</th>
                                            <th>{label.Release}</th>
                                            <th>{label.Created}</th>
                                            <th>{label.LastUpdate}</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            allTasks.map((item, index)=>{
                                                return (
                                                    <tr key={item.id}>
                                                        <th scope="row">{((this.state.page-1)* this.state.pageElement)+(++index)}</th>
                                                        <td>
                                                            <span className="font-weight-bolder h6">{item.reference}</span>
                                                            {item.serialCode&&(
                                                                <React.Fragment>
                                                                    <br/>
                                                                    <span className="h6">SN:</span>&nbsp;<span className="font-italic text-primary h5">{item.serialCode}</span>
                                                                </React.Fragment>
                                                            )}
                                                        </td>
                                                        <td className="text-wrap">
                                                            {item.model.modelCategory.name}
                                                            <br/>
                                                            <a
                                                                href="#"
                                                                onClick={async (e) => {
                                                                    e.preventDefault()
                                                                    await this.fetchModelDetail(item.model.id)
                                                                }}>
                                                                {item.model.systemType}
                                                            </a>
                                                            <br/>
                                                            <span className="h5">{label.PN}:</span><span className="font-italic text-underline h5">{item.model.partNumber}</span>
                                                        </td>
                                                        <td className="justify-content-center align-content-center align-items-center">
                                                            {item.assemblyPerformer?(
                                                                <React.Fragment>
                                                                    <StatusWidget
                                                                        statusColors={ASSEMBLY_STATUS_COLOR}
                                                                        status={item.assemblyStatus}
                                                                        disabled={false}
                                                                        onClick={(e) => {
                                                                            this.fetchAssemblyBasicInformation(item.assembly.id)
                                                                        }}
                                                                        icon={<FaInfo/>}/>
                                                                    <br/>
                                                                    <UserButton style={{marginTop:'6px'}} user={item.assemblyPerformer}/>
                                                                </React.Fragment>
                                                            ):(<span>N/A</span>)}
                                                        </td>
                                                        <td className="justify-content-center align-content-center align-items-center">
                                                            {item.inspectionPerformer?(
                                                                <React.Fragment>
                                                                    <StatusWidget
                                                                        statusColors={INSPECTION_STATUS_COLOR}
                                                                        status={item.inspectionStatus}
                                                                        disabled={false}
                                                                        onClick={(e) => {
                                                                            this.fetchInspectionDetail(item.inspection.id)
                                                                        }}
                                                                        icon={<FaInfo/>}/>
                                                                    <br/>
                                                                    <UserButton style={{marginTop:'6px'}} user={item.inspectionPerformer}/>
                                                                </React.Fragment>
                                                            ):(<span>N/A</span>)}
                                                        </td>
                                                        <td className="justify-content-center align-content-center align-items-center">
                                                            {item.releaseVerificationPerformer?(
                                                                <React.Fragment>
                                                                    <StatusWidget
                                                                        statusColors={RELEASE_VERIFICATION_STATUS_COLOR}
                                                                        status={item.releaseVerificationStatus}
                                                                        disabled={false}
                                                                        onClick={(e) => {
                                                                            this.fetchReleaseVerificationDetail(item.releaseVerification.id)
                                                                        }}
                                                                        icon={<FaInfo/>}/>
                                                                    <br/>
                                                                    <UserButton style={{marginTop:'6px'}} user={item.releaseVerificationPerformer}/>
                                                                </React.Fragment>
                                                            ):(<span>N/A</span>)}
                                                        </td>
                                                        <td className="justify-content-center align-content-center align-items-center">{parseDate(item.created, DD_MMMM_YYYY_HH_MM_SS)}</td>
                                                        <td className="justify-content-center align-content-center align-items-center">{parseDate(item.updated, DD_MMMM_YYYY_HH_MM_SS)}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                        </tbody>
                                    </Table>
                                </Row>
                            </CardBody>
                            <Pagination {...this.props} currentPage={parseInt(this.state.page)} pageCount={this.state.totalPage} />
                        </Card>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}
export default Object.assign(AllTaskPage, {ENDPOINT : "/allTasks"})
